import { CategoryStorageType } from "../../types";

type ItemKeyCacheSet = Set<string>;

type ItemKeyCacheByType = Record<CategoryStorageType, ItemKeyCacheSet>;

class ItemKeyCacheService {
    private cache: ItemKeyCacheByType;

    constructor() {
        this.cache = Object.fromEntries(
            Object.keys(CategoryStorageType).map((storageType) => {
                return [storageType, new Set<string>()];
            }
        )) as ItemKeyCacheByType;
    }

    markSetByPackage(storageType: CategoryStorageType, itemKey: string): void {
        this.cache[storageType].add(itemKey);
    }

    wasSetByPackage(storageType: CategoryStorageType, itemKey: string): boolean {
        return this.cache[storageType].has(itemKey);
    }
}

const ItemKeyCache: ItemKeyCacheService = new ItemKeyCacheService();

export { ItemKeyCache }
